import React, { useEffect,useState } from "react";
import HeaderPage from "../../Component/HeaderPage/HeaderPage";

import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import DonutChart from "../../Component/DonutChart/DonutChart";
import ColumnCylinder from "../../Component/CylinderColumnChart/ColumnCylinder";

import './index.css'

const Qualys = () => {
    const [dataset, setData] = useState([]);

    useEffect(() => {
        const URL = " https://apm-app3.alphait.us/Qualys/GetQualysData"

        fetch(URL)
            .then((response) => {
                return response.json();
            })
            .then((data) => {

                setData(data);
            });

    }, []);

    return (
        <div className="qualys">
            <HeaderPage text="qualys"/>
            <span className="qualys-type">VULNERABILITIES</span>
            <Grid className="qualys-chart" item>
                {(dataset.qualysSeverity && dataset.qualysType) ? (
                    <>
                        <Grid xs={6} className="chart-box">
                            <ColumnCylinder datasets={dataset.qualysSeverity}/>
                        </Grid>
                        <Grid xs={6} className="chart-box">
                            <DonutChart datasets={dataset.qualysType} />
                        </Grid>
                    </>
                ) : (
                    <div className="qualys-loading">
                        <span className="qualys-loading-label">Loading data from server...</span>
                        <CircularProgress/>
                    </div>
                )}
            </Grid>
        </div>
    );
}

export default Qualys;